export type Filter = (n: Node) => Boolean;
export type Dnode = { node: Node; children?: Dnode[] };

// import { linkToDoc } from "./http";

export const traverseNodes = (node: Node, pred: Filter, skip: Filter) => {
  let all: Dnode[] = [];

  for (node = node.firstChild; node; node = node.nextSibling) {
    if (skip(node)) continue;
    const traverse = !pred(node);

    if (traverse) {
      // if (node.nodeName === "A") {
      //   linkToDoc(node.getAttribute("href"))
      //     .then(console.log)
      //     .catch((x) => {});
      // }

      const children = traverseNodes(node, pred, skip);
      children.length && all.push({ node, children });
    } else {
      all.push({ node });
    }
  }

  return all;
};

const getCh = (dn: Dnode | Dnode[]) => (Array.isArray(dn) ? dn : dn.children);

export const forEach = (dn: Dnode | Dnode[], fn: (_: Dnode) => void) =>
  getCh(dn)?.forEach((c) => (c.children ? forEach(c, fn) : fn(c)));

export const map = <T>(dn: Dnode | Dnode[], fn: (_: Dnode) => T[]) =>
  getCh(dn)?.reduce((acc, curr) => (curr.children ? acc.concat(map(curr.children, fn)) : [...acc, fn(curr)]), []);

// window.fmap = map;
